import { AudioMixing } from './AudioMixing'
import { Subject } from 'rxjs/Subject'
import { filter } from 'rxjs/operators/filter'
import { map } from 'rxjs/operators/map'

export class AudioController {
  constructor () {
    this.mixing = new AudioMixing()
    this.subject = new Subject()
  }

  async startMixing ({ filePath, volume }) {
    let finished = (object) => {
      this.subject.next({ type: 'audio-finished', result: object })
    }
    const { preFilePath, audio } = await this.mixing.startMixing({ filePath, finished, volume })
    if (preFilePath) {
      // 之前播放中的音频停止并重置状态
      this.subject.next({ type: 'audio-stoped', result: { filePath: preFilePath } })
    }
    this.mixing.updateProcess(filePath, 200, (object) => {
      this.subject.next({ type: 'audio-progress', result: object })
    })
    return { audio }
  }

  confluence (wrappedStream) {
    return this.mixing.confluence(wrappedStream)
  }

  /**
   * 将需要混音的音频源连接到destination上即可
   * @param audio
   * @param isConnectMediaElement
   */
  connectMediaElementToDest (audio, isConnectMediaElement) {
    return this.mixing.connectMediaElementToDest(audio, isConnectMediaElement)
  }

  disconnectMediaElementFromDest() {
    return this.mixing.disconnectMediaElementFromDest()
  }

  setMicroVolume (volume) {
    this.mixing.setMicroVolume(volume)
  }

  resumeDefaultVolume () {
    this.mixing.resumeDefaultVolume()
  }

  /**
   * 暂停混音
   * @returns {Promise<*>}
   */
  async pauseMixing () {
    return this.mixing.pauseMixing()
  }

  /**
   * 恢复混音
   * @param filePath
   * @returns {Promise<*>}
   */
  resumeMixing (filePath) {
    return this.mixing.resumeMixing(filePath)
  }

  /**
   * 停止混音
   */
  stopMixing () {
    return this.mixing.stopMixing()
  }

  /**
   * 删除音频对象
   * @returns {*}
   */
  deleteAudio () {
    return this.mixing.deleteAudio()
  }
  /**
   * 设置混音音量
   * @param volume
   * @returns {Promise<string|void>}
   */
  setMixingVolume (volume) {
    return this.mixing.setMixingVolume(volume)
  }

  /**
   * 监听混音进度
   * @returns {Observable<any>}
   */
  mixingProgress () {
    return this.subject.pipe(filter((e) => e.type === 'audio-progress')).pipe(map(e => e.result))
  }

  /**
   * 监听混音完成状态
   * @returns {Observable<any>}
   */
  mixingFinished () {
    return this.subject.pipe(filter((e) => e.type === 'audio-finished')).pipe(map(e => e.result))
  }

  /**
   * 监听混音停止状态
   * @returns {Observable<any>}
   */
  mixingStoped () {
    return this.subject.pipe(filter((e) => e.type === 'audio-stoped')).pipe(map(e => e.result))
  }
}
